import React from 'react';
// TODO this entire function could probably be cleaned up and improved using recursive functions, or any other approach really.
// Review how some existing parsing libraries do this sort of thing
/** Parses &#8480; (or &amp;#8480;) and &trade; (or &amp;trade;) and adds them as JSX.Element */
export const addSuperscript = (text) => {
    // If text is undefined/falsy, return null.
    // This is to make sure that components where text is optional returns a falsy value and renders unsupportedContent if it is available.
    if (!text)
        return null;
    // Split the string wherever &#8480; or &amp;#8480; appears.
    const smSplit = text.split(/&amp;#8480;|&#8480;/);
    // Take every string in `smSplit` and split it wherever &trade; &amp;trade; appears.
    const smtmSplit = (() => {
        return smSplit.map(x => x.split(/&amp;trade;|&trade;/));
    })();
    // Convert smtmSplit into JSX.Elements, re-adding (ie appending) &#8480; and &trade; as elements where the strings were split.
    return (React.createElement(React.Fragment, null, smtmSplit.map((x, xIndex) => {
        const mappedItem = x.map((y, yIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(React.Fragment, { key: `${y} ${yIndex}` },
            y,
            yIndex !== x.length - 1 && React.createElement(React.Fragment, null, "\u2122"))));
        return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(React.Fragment, { key: `${x.toString()} ${xIndex}` },
            mappedItem,
            xIndex !== smtmSplit.length - 1 && React.createElement(React.Fragment, null, "\u2120")));
    })));
};
//# sourceMappingURL=addSuperscript.js.map